<div id="content" class="main-content">
    <div class="container">
        <div class="layout-spacing">
            <div class="widget-content widget-content-area pl-0 pr-1">
                <div class="page-header">
                    <div class="page-title mt-3 row col-lg-12 col-md-12 d-flex justify-content-between">
                        <div class="mb-3">
                            <img [src]="logo ? 'data:image/jpg;base64,' + logo : 'assets/img/logo.jpg'" 
                                 class="img-fluid mr-2 col-xs-12 logo_company" style="height: 100px;">
                        </div>                        
                        <h2 style="color:black">
                            <img src="../assets/img/suivitim_img/logo_menu.png" width="200">
                        </h2>
                    </div>
                </div>
                <div *ngIf="laoding" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 7%;margin-bottom: 1%;"></div> 
                <div  *ngIf="!laoding" class="mx-4">
                    <div class="d-flex justify-content-center mb-4">
                        <h3>Enquête de satisfaction</h3>
                    </div>
                    <form class="form-login form-group mt-2" [formGroup]="surveyResponse" novalidate>
                        <div *ngIf="laodingSending" class="cp-spinner cp-bubble loading"></div> 
                        <ng-container *ngFor="let question of questions; let i = index">
                            <div class="row d-flex justify-content-center mb-5 mt-5">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" [ngClass]="{'d-flex align-items-center': question.type === 'st'}">
                                    {{ question.qst }}
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="display: block;">
                                    <ng-container *ngIf="question.type === 'st'">
                                        <div class="stars">
                                            <input type="radio" [name]="'rating' + i" [formControlName]="'rating' + i" [id]="'star5-' + i" value="5">
                                            <label [for]="'star5-' + i"></label>
                                            <input type="radio" [name]="'rating' + i" [formControlName]="'rating' + i" [id]="'star4-' + i" value="4">
                                            <label [for]="'star4-' + i"></label>
                                            <input type="radio" [name]="'rating' + i" [formControlName]="'rating' + i" [id]="'star3-' + i" value="3">
                                            <label [for]="'star3-' + i"></label>
                                            <input type="radio" [name]="'rating' + i" [formControlName]="'rating' + i" [id]="'star2-' + i" value="2">
                                            <label [for]="'star2-' + i"></label>
                                            <input type="radio" [name]="'rating' + i" [formControlName]="'rating' + i" [id]="'star1-' + i" value="1">
                                            <label [for]="'star1-' + i"></label>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="question.type === 'ch'">
                                        <div style="display: flex; justify-content: space-evenly">
                                            <div>
                                                <label class="new-control new-checkbox new-checkbox-rounded checkbox-success">
                                                    <input type="radio" [name]="'option' + i" [formControlName]="'option' + i" value="oui" class="new-control-input">
                                                    <span class="new-control-indicator"></span>Oui
                                                </label>
                                            </div>
                                            <div>
                                                <label class="new-control new-checkbox new-checkbox-rounded checkbox-success">
                                                    <input type="radio" [name]="'option' + i" [formControlName]="'option' + i" value="non" class="new-control-input">
                                                    <span class="new-control-indicator"></span>Non
                                                </label>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="question.type === 'fr'">
                                        <textarea class="form-control pl-3 pr-3" rows="2" placeholder="Saisir Votre commentaire" style="height: 150px;" [formControlName]="'comment' + i" [name]="'comment' + i" (input)="sanitizeInput($event)"></textarea>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>
                        
                        <div class="row d-flex justify-content-end mr-2">
                            <h3 class="readonly-text text-muted font-italic">{{ customerRs }}</h3>
                        </div>                        
                        <div class="row d-flex justify-content-center">
                            <button type="submit" class="btn btn-gradient-success btn-rounded mt-3 mb-4" (click)="sendSurveyResponse()">
                                Envoyer
                            </button>
                        </div>
                    </form>
                    
                </div>
            </div>
        </div>
    </div>
</div>

 <!-- Modal -->
<div class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header d-flex justify-content-center" style="flex-direction: column; align-items: center;">
                <h4 class="modal-title" id="staticBackdropLabel">Votre réponse a été envoyée avec succès!</h4>
                <img src="../../assets/img/terminated.gif" width="150">

            </div>
        </div>
    </div>
</div>


 <!-- Modal -->
 <div class="modal fade" id="error" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="errorLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header d-flex justify-content-center" style="flex-direction: column; align-items: center;">
                <h4 class="modal-title" id="errorLabel">Vous avez déjà répondu à cet enquête!</h4>
                <img src="../../assets/img/error.gif" width="250">
            </div>
        </div>
    </div>
</div>